import React from 'react';

// =============================================
// ASSETS SECTION COMPONENT
// =============================================

export function AssetsSection({
    // Gold module
    goldInventory,
    filteredGoldInventory,
    sgdRate,
    // Accounts module
    accounts,
    filteredAccounts,
    accountTotals,
    // Shared search
    searchQuery,
    setSearchQuery,
    // UI state
    activeModule,
    // Modal handlers
    setModalType,
    setShowAddModal,
    setEditingItem,
    setShowEditModal,
    // Formatting
    baseCurrencyLabel,
    fmtBase,
    toBase,
}) {
    return (
        <>
            {activeModule === 'gold' && (
                <>
                    <div className="search-container">
                        <div className="search-wrapper">
                            <span className="search-icon">🔍</span>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Search gold items..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <button
                                    className="clear-search visible"
                                    onClick={() => setSearchQuery('')}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="section-container">
                        <div className="section-header">
                            <div>
                                <div className="section-title">Gold Inventory</div>
                                <div className="section-subtitle">{filteredGoldInventory.length} items</div>
                            </div>
                            <button
                                className="add-btn"
                                onClick={() => {
                                    setModalType('gold-inventory');
                                    setShowAddModal(true);
                                }}
                            >
                                + Add
                            </button>
                        </div>

                        {filteredGoldInventory.length === 0 ? (
                            <div className="empty-state">
                                <div className="empty-icon">💎</div>
                                <div className="empty-text">No gold items found</div>
                            </div>
                        ) : (
                            filteredGoldInventory.map((item, index) => {
                                const rate = item.quality === '18K' ? sgdRate * 0.75 : sgdRate;
                                const sgdValue = item.weight * rate;

                                return (
                                    <div
                                        key={index}
                                        className="item-card"
                                        onClick={() => {
                                            setModalType('gold-inventory');
                                            setEditingItem(item);
                                            setShowEditModal(true);
                                        }}
                                    >
                                        <div className="card-header">
                                            <div>
                                                <div className="card-title">{item.name}</div>
                                                <div className="card-subtitle">{item.type} • {item.owner}</div>
                                            </div>
                                            <div className="card-badge">{item.quality}</div>
                                        </div>

                                        <div className="card-details">
                                            <div className="detail-item">
                                                <div className="detail-label">Weight</div>
                                                <div className="detail-value">{item.weight}g</div>
                                            </div>
                                            <div className="detail-item">
                                                <div className="detail-label">Pawn</div>
                                                <div className="detail-value">{item.pawn}</div>
                                            </div>
                                            <div className="detail-item">
                                                <div className="detail-label">SGD Value</div>
                                                <div className="detail-value">${Math.round(sgdValue).toLocaleString()}</div>
                                            </div>
                                            <div className="detail-item">
                                                <div className="detail-label">{baseCurrencyLabel} Value</div>
                                                <div className="detail-value highlight">{fmtBase(toBase(sgdValue, 'SGD'))}</div>
                                            </div>
                                        </div>

                                        {item.comment && (
                                            <div style={{ fontSize: '12px', color: '#FFD700', marginTop: '8px', fontStyle: 'italic' }}>
                                                {item.comment}
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        )}
                    </div>
                </>
            )}

            {activeModule === 'accounts' && (
                <>
                    <div className="search-container">
                        <div className="search-wrapper">
                            <span className="search-icon">🔍</span>
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Search accounts..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            {searchQuery && (
                                <button
                                    className="clear-search visible"
                                    onClick={() => setSearchQuery('')}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="section-container">
                        <div className="section-header">
                            <div>
                                <div className="section-title">Bank Accounts</div>
                                <div className="section-subtitle">{filteredAccounts.length} accounts</div>
                            </div>
                            <button
                                className="add-btn"
                                onClick={() => {
                                    setModalType('account');
                                    setShowAddModal(true);
                                }}
                            >
                                + Add
                            </button>
                        </div>

                        {/* Summary Card */}
                        <div className="summary-card" style={{ marginBottom: '20px' }}>
                            <div className="summary-card-title">💰 Total Balances</div>
                            <div className="summary-stats">
                                <div className="summary-stat">
                                    <div className="summary-stat-value">{fmtBase(accountTotals.totalBase)}</div>
                                    <div className="summary-stat-label">{baseCurrencyLabel} Total</div>
                                </div>
                                <div className="summary-stat">
                                    <div className="summary-stat-value">${accountTotals.totalSGD.toLocaleString()}</div>
                                    <div className="summary-stat-label">SGD</div>
                                </div>
                                <div className="summary-stat">
                                    <div className="summary-stat-value">₨{Math.round(accountTotals.totalLKR).toLocaleString()}</div>
                                    <div className="summary-stat-label">LKR</div>
                                </div>
                            </div>
                        </div>

                        {filteredAccounts.length === 0 ? (
                            <div className="empty-state">
                                <div className="empty-icon">🏦</div>
                                <div className="empty-text">No accounts found</div>
                            </div>
                        ) : (
                            filteredAccounts.map(account => (
                                <div
                                    key={account.id}
                                    className="item-card"
                                    onClick={() => {
                                        setModalType('account');
                                        setEditingItem(account);
                                        setShowEditModal(true);
                                    }}
                                >
                                    <div className="card-header">
                                        <div>
                                            <div className="card-title">{account.accountName}</div>
                                            <div className="card-subtitle">{account.bank} • {account.country}</div>
                                        </div>
                                        <div className="card-badge">{account.currency}</div>
                                    </div>

                                    <div className="card-details">
                                        <div className="detail-item">
                                            <div className="detail-label">Account Number</div>
                                            <div className="detail-value">{account.accountNumber}</div>
                                        </div>
                                        <div className="detail-item">
                                            <div className="detail-label">SGD Balance</div>
                                            <div className={`detail-value ${account.currency === 'SGD' ? 'highlight' : ''}`}>
                                                ${account.balanceSGD.toLocaleString()}
                                            </div>
                                        </div>
                                        <div className="detail-item">
                                            <div className="detail-label">USD Balance</div>
                                            <div className={`detail-value ${account.currency === 'USD' ? 'highlight' : ''}`}>
                                                ${account.balanceUSD.toLocaleString()}
                                            </div>
                                        </div>
                                        <div className="detail-item">
                                            <div className="detail-label">LKR Balance</div>
                                            <div className={`detail-value ${account.currency === 'LKR' ? 'highlight' : ''}`}>
                                                ₨{account.balanceLKR.toLocaleString()}
                                            </div>
                                        </div>
                                        <div className="detail-item">
                                            <div className="detail-label">≈ {baseCurrencyLabel} Equiv.</div>
                                            <div className="detail-value highlight">
                                                {fmtBase(toBase(account[`balance${account.currency || 'SGD'}`] || 0, account.currency || 'SGD'))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </>
            )}
        </>
    );
}